// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout route for integrations pages.
 * Renders child routes via Outlet.
 */
export const Route = createFileRoute('/_app/integrations')({
  component: IntegrationsLayout,
});

function IntegrationsLayout() {
  return <Outlet />;
}
